import { render, staticRenderFns } from "./footBox.vue?vue&type=template&id=89018a26&scoped=true"
import script from "./footBox.vue?vue&type=script&lang=js"
export * from "./footBox.vue?vue&type=script&lang=js"
import style0 from "./footBox.vue?vue&type=style&index=0&id=89018a26&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89018a26",
  null
  
)

export default component.exports